<template>
    <md-toolbar id="main-navbar"
        md-elevation="0"
        class="md-primary md-fixed-top md-toolbar-fixed px-2"
        :class="{'md-toolbar-absolute md-white md-fixed-top': $route.meta.navbarAbsolute}"
    >
        <div class="md-toolbar-row pl-0 pr-2">
            <div class="md-toolbar-section-start">
                <div class="flex flex-col">
                    <span class="text-sm font-medium pl-1 mb-0.5 leading-none">{{ user ? user.full_name : 'Utilisateur' }}</span>
                    <span class="text-xs italic font-medium pl-1 leading-none">
	                    {{ isOnline ? 'En ligne' : 'Hors-ligne' }} {{ (isOnline && requestsCount > 0) ? ' | Envoi des données en cours' : '' }}
                    </span>
                </div>
            </div>
            <md-list>
                <md-list-item @click="logout">
                    <i class="md-icon fas fa-sign-out-alt"></i>
                </md-list-item>
            </md-list>
        </div>
    </md-toolbar>
</template>

<script>

import { mapState } from "vuex";
import indexedDBMixin from "@/mixins/indexed-db-mixin";

export default {
    name: "Header",
	mixins: [indexedDBMixin],
	props: {
		isOnline: Boolean,
        requestsCount: Number,
	},
    data() {
        return {}
    },
    computed: mapState({
        user: state => state.pwaAuth.technician
    }),
    methods: {
        async logout() {
	        const requests = await this.getRequestsInIndexedDB('requests')
            if(requests.length === 0) {
                await this.$store.dispatch("pwaAuth/pwaLogout", {
                    access_token: JSON.parse(localStorage.getItem('pwa')).access_token,
                    user_id: this.user.id
                }).then(async () => {
					await this.clearIndexedDBTable('data')
                })
            } else {
                await this.$store.dispatch('alerts/warning', 'Déconnexion impossible, toutes les données n\'ont pas encore été synchronisées')
            }
        },
    }
}
</script>

<style scoped lang="scss">
.md-toolbar {
    max-height: 42px;
    min-height: 42px;

    ::v-deep {
        .md-list {
            padding: 0;
            margin-right: -7px;
            .md-list-item, .md-list-item-button {
                transition: all 150ms ease-in;
                color: inherit !important;
                font-weight: 400 !important;
                font-size: 14px !important;
                overflow: visible !important;
                border-radius: 3px !important;
                position: relative !important;
                display: block !important;
                padding: 0 !important;
                text-decoration: none !important;

                .md-ripple {
                    min-height: 25px !important;
                    padding: 5px 10px;
                }

                svg {
                    margin: 0 !important;
                    line-height: 30px;
                    min-width: 16px !important;
                    font-size: 16px !important;
                }
            }
            .md-list-item:hover {
                background: rgba(200, 200, 200, 0.2) !important;
            }
            .md-list-item-button:hover {
                background-color: transparent !important;
            }
        }
    }
}
.md-list-item, .md-list-item-button {
    transition: all 150ms ease-in;
    color: inherit !important;
    font-weight: 400 !important;
    font-size: 14px !important;
    overflow: visible !important;
    border-radius: 3px !important;
    position: relative !important;
    display: block !important;
    padding: 0 !important;
    text-decoration: none !important;

    svg {
        margin: 0 !important;
        line-height: 30px;
        min-width: 16px !important;
        font-size: 16px !important;
    }
}
.md-list-item:hover {
    background: rgba(200, 200, 200, 0.2) !important;
}
.md-list-item-button:hover {
    background-color: transparent !important;
}
</style>
